AFRAME.registerComponent("raycastervr", {
    schema: {
        autoRefresh: { default: true },
        direction: { type: "vec3", default: { x: 0, y: 0, z: -1 } },
        enabled: { default: true },
        far: { default: 1000 },
        interval: { default: 0 },
        near: { default: 0 },
        objects: { default: "" },
        origin: { type: "vec3" },
        showLine: { default: false },
        useWorldCoordinates: { default: false },
    },
    multiple: true,
    init: function () {
        this.clearedIntersectedEls = [];
        this.unitLineEndVec3 = new THREE.Vector3();
        this.intersectedEls = [];
        this.intersections = [];
        this.newIntersectedEls = [];
        this.newIntersections = [];
        this.objects = [];
        this.prevCheckTime = undefined;
        this.prevIntersectedEls = [];
        this.rawIntersections = [];
        this.raycaster = new THREE.Raycaster();
        this.raycaster.firstHitOnly = true;
        this.updateOriginDirection();
        this.setDirty = this.setDirty.bind(this);
        this.updateLine = this.updateLine.bind(this);
        this.observer = new MutationObserver(this.setDirty);
        this.dirty = true;
        this.lineEndVec3 = new THREE.Vector3();
        this.otherLineEndVec3 = new THREE.Vector3();
        this.lineData = {
            end: this.lineEndVec3,
        };
        this.getIntersection = this.getIntersection.bind(this);
        this.intersectedDetail = {
            el: this.el,
            getIntersection: this.getIntersection,
        };
        this.intersectedClearedDetail = {
            el: this.el,
        };
        this.intersectionClearedDetail = {
            clearedEls: this.clearedIntersectedEls,
        };
        this.intersectionDetail = {};
    },
    update: function (previousData) {
        const currentData = this.data;
        const element = this.el;
        const raycaster = this.raycaster;

        raycaster.far = currentData.far;
        raycaster.near = currentData.near;
        raycaster.firstHitOnly = true;

        if (
            !currentData.showLine ||
            (currentData.far === previousData.far &&
                currentData.origin === previousData.origin &&
                currentData.direction === previousData.direction &&
                previousData.showLine)
        ) {
            this.unitLineEndVec3
                .copy(currentData.origin)
                .add(currentData.direction)
                .normalize();
            this.drawLine();
        } else if (!currentData.showLine) {
            element.removeAttribute("line");
        }

        if (
            currentData.objects !== previousData.objects &&
            /^[\w\s-.,[\]#]*$/.test(currentData.objects)
        ) {
            currentData.objects;
        }

        if (
            currentData.autoRefresh !== previousData.autoRefresh &&
            element.isPlaying
        ) {
            currentData.autoRefresh
                ? this.addEventListeners()
                : this.removeEventListeners();
        }

        if (previousData.enabled && !currentData.enabled) {
            this.clearAllIntersections();
        }

        this.setDirty();
    },
    play: function () {
        this.addEventListeners();
    },
    pause: function () {
        this.removeEventListeners();
    },
    remove: function () {
        if (this.data.showLine) {
            this.el.removeAttribute("line");
        }
        this.clearAllIntersections();
    },
    addEventListeners: function () {
        if (this.data.autoRefresh) {
            this.observer.observe(this.el.sceneEl, {
                childList: true,
                attributes: true,
                subtree: true,
            });
            this.el.sceneEl.addEventListener("object3dset", this.setDirty);
            this.el.sceneEl.addEventListener("object3dremove", this.setDirty);
        }
    },
    removeEventListeners: function () {
        this.observer.disconnect();
        this.el.sceneEl.removeEventListener("object3dset", this.setDirty);
        this.el.sceneEl.removeEventListener("object3dremove", this.setDirty);
    },
    setDirty: function () {
        this.dirty = true;
    },
    refreshObjects: function () {
        let objectList;
        const { data } = this;
        objectList = data.objects
            ? this.el.sceneEl.querySelectorAll(data.objects)
            : this.el.sceneEl.querySelectorAll("*");
        this.objects = this.flattenObject3DMaps(objectList);
        this.dirty = false;
    },
    tick: function (t) {
        var n = this.data,
            r = this.prevCheckTime;
        n.enabled &&
            ((r && t - r < n.interval) ||
                ((this.prevCheckTime = t), this.checkIntersections()));
    },
    checkIntersections: function () {
        let index;
        let intersection;
        let {
            clearedIntersectedEls,
            el,
            data,
            intersectedEls,
            intersections,
            newIntersectedEls,
            newIntersections,
            prevIntersectedEls,
            rawIntersections,
        } = this;
        if (this.dirty) {
            this.refreshObjects();
        }
        this.updateOriginDirection();
        rawIntersections.length = 0;
        this.raycaster.firstHitOnly = true;
        rawIntersections = this.raycaster.intersectObjects(this.objects, true);
        intersections.length = 0;
        intersectedEls.length = 0;

        for (index = 0; index < rawIntersections.length; index++) {
            intersection = rawIntersections[index];
            if (
                (!data.showLine ||
                    intersection.object !== el.getObject3D("line")) &&
                intersection.object.el
            ) {
                intersections.push(intersection);
                intersectedEls.push(intersection.object.el);
                break;
            }
        }
        for (index = 0; index < intersections.length; index++) {
            if (
                prevIntersectedEls.indexOf(intersections[index].object.el) ===
                -1
            ) {
                newIntersections.push(intersections[index]);
                newIntersectedEls.push(intersections[index].object.el);
            }
        }
        clearedIntersectedEls.length = 0;
        for (index = 0; index < prevIntersectedEls.length; index++) {
            if (intersectedEls.indexOf(prevIntersectedEls[index]) === -1) {
                prevIntersectedEls[index].emit(
                    "raycaster-intersected-cleared",
                    this.intersectedClearedDetail
                );
                clearedIntersectedEls.push(prevIntersectedEls[index]);
            }
        }
        if (clearedIntersectedEls.length) {
            el.emit(
                "raycaster-intersection-cleared",
                this.intersectionClearedDetail
            );
            this.el.sceneEl.classList.remove("pointer-cursor");
            this.el.sceneEl.classList.add("grab-cursor");
        }
        for (index = 0; index < newIntersectedEls.length; index++) {
            newIntersectedEls[index].emit(
                "raycaster-intersected",
                this.intersectedDetail
            );
        }
        if (newIntersections.length) {
            this.intersectionDetail.els = newIntersectedEls;
            this.intersectionDetail.intersections = newIntersections;
            el.emit("raycaster-intersection", this.intersectionDetail);
            this.el.sceneEl.classList.remove("grab-cursor");
            this.el.sceneEl.classList.add("pointer-cursor");
        }
        if (data.showLine) {
            setTimeout(this.updateLine);
        }
    },
    updateLine: function () {
        let distance;
        const { el, data, intersections } = this;
        if (intersections.length) {
            distance =
                intersections[0].object.el === el && intersections[1]
                    ? intersections[1].distance
                    : intersections[0].distance;
        }
        this.drawLine(distance);
    },
    getIntersection: function (targetElement) {
        let index;
        let intersection;
        for (index = 0; index < this.intersections.length; index++) {
            intersection = this.intersections[index];
            if (intersection.object.el === targetElement) {
                return intersection;
            }
        }
        return null;
    },
    updateOriginDirection: (function () {
        const origin = new THREE.Vector3();
        const direction = new THREE.Vector3();
        return function () {
            const { el, data } = this;
            if (data.useWorldCoordinates) {
                this.raycaster.set(data.origin, data.direction);
            } else {
                el.object3D.updateMatrixWorld();
                direction.setFromMatrixPosition(el.object3D.matrixWorld);
                if (
                    data.origin.x !== 0 ||
                    data.origin.y !== 0 ||
                    data.origin.z !== 0
                ) {
                    direction
                        .copy(data.origin)
                        .applyMatrix4(el.object3D.matrixWorld);
                }
                origin
                    .copy(data.direction)
                    .transformDirection(el.object3D.matrixWorld)
                    .normalize();
                this.raycaster.set(direction, origin);
            }
        };
    })(),
    drawLine: function (distance) {
        let lineEnd;
        const { data, el } = this;
        lineEnd =
            this.lineData.end === this.lineEndVec3
                ? this.otherLineEndVec3
                : this.lineEndVec3;
        if (distance === undefined) {
            distance = data.far === Infinity ? 1000 : data.far;
        }
        this.lineData.start = data.origin;
        this.lineData.end = lineEnd
            .copy(this.unitLineEndVec3)
            .multiplyScalar(distance);
        el.setAttribute("line", this.lineData);
    },
    flattenObject3DMaps: function (elementList) {
        let index;
        let objectKey;
        const objects = [];
        for (index = 0; index < elementList.length; index++) {
            if (elementList[index].isEntity && elementList[index].object3D) {
                for (objectKey in elementList[index].object3DMap) {
                    objects.push(elementList[index].getObject3D(objectKey));
                }
            }
        }
        return objects;
    },
    clearAllIntersections: function () {
        let index;
        for (index = 0; index < this.intersectedEls.length; index++) {
            this.intersectedEls[index].emit(
                "raycaster-intersected-cleared",
                this.intersectedClearedDetail
            );
        }
        Array.prototype.splice.apply(
            this.clearedIntersectedEls,
            [0, this.clearedIntersectedEls.length].concat(this.intersectedEls)
        );
        this.intersectedEls.length = 0;
        this.intersections.length = 0;
        this.el.emit(
            "raycaster-intersection-cleared",
            this.intersectionClearedDetail
        );
    },
});
